import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import Typography from '@mui/material/Typography';
import getTransformedDate from 'utils/getTransformedDate';
import { AppointmentResponseViewModel, AppointmentStatus } from 'types/appointment';
import { AppointmentStatusLabel } from 'components/Appointments/Statuses';

interface Props {
    item: ITableHeadCell;
    rowData: AppointmentResponseViewModel;
}

export const AppointmentListCell = ({ rowData: data, item }: Props) => {
    const field =
        data[
            item.field as keyof Pick<
                AppointmentResponseViewModel,
                'title' | 'scheduledDateTime' | 'dateConfirmed' | 'email' | 'address' | 'phoneNumber'
            >
        ];

    if (item.field === 'dateConfirmed') {
        return <Typography variant="body2">{getTransformedDate(field as string, 'MM/DD/YYYY') || '--'}</Typography>;
    }

    if (item.field === 'scheduledDateTime') {
        return (
            <Typography variant="body2">
                {getTransformedDate(field as string, 'MM/DD/YYYY') || 'not confirmed'}
            </Typography>
        );
    }
    if (item.field === 'status') {
        return <AppointmentStatusLabel status={field as AppointmentStatus} />;
    }

    return (
        <Typography noWrap variant="body2">
            {field || '--'}
        </Typography>
    );
};
